<div class="chart-container">
  <ng-container *ngIf="chartType === horizontalChartType">
    <div class="chart-background">
      <div class="progress-percent">
        {{ realisedInPercent | number:'1.0-1' }}%
      </div>

      <div
        *ngIf="iddTraining.requiredAssetsMinutes"
        class="chart-background-blue"
        [ngStyle]="{'width': (100 * iddTraining.requiredAssetsMinutes / totalRequiredMinutes) + '%'}"
      >
        <div
          class="chart-realised"
          [ngStyle]="{'width': realisedAssetsInPercent + '%'}"
          [matTooltip]="'Majątek: zrealizowane ' + (floor((iddTraining.requiredAssetsMinutes - iddTraining.leftAssetsMinutes)/ 60).toString() | number:'1.0-0')+ 'h ' +
            (floor((iddTraining.requiredAssetsMinutes - iddTraining.leftAssetsMinutes)% 60).toString() | number:'1.0-0')+ 'min'"
          matTooltipPosition="above"
        >
        </div>

        <div
          class="chart-left-minutes"
          [ngStyle]="{'width': (100 - realisedAssetsInPercent) + '%'}"
          [matTooltip]="'Majątek: pozostało ' + (floor((iddTraining.leftAssetsMinutes) / 60).toString() | number:'1.0-0') + 'h ' +
            ((floor(iddTraining.leftAssetsMinutes) % 60).toString() | number:'1.0-0') + 'min'"
          matTooltipPosition="above"
          ></div>
      </div>


      <div
        *ngIf="iddTraining.requiredLifeMinutes"
        class="chart-background-orange"
        [ngStyle]="{'width': (100 * iddTraining.requiredLifeMinutes / totalRequiredMinutes) + '%'}"
      >
        <div
          class="chart-realised"
          [ngStyle]="{'width': realisedLifeInPercent + '%'}"
          [matTooltip]="'Życie: zrealizowane ' + (floor((iddTraining.requiredLifeMinutes - iddTraining.leftLifeMinutes)/ 60).toString() | number:'1.0-0') + 'h ' +
            (floor((iddTraining.requiredLifeMinutes - iddTraining.leftLifeMinutes)% 60).toString() | number:'1.0-0') + 'min'"
          matTooltipPosition="above"
        >

        </div>

        <div
          class="chart-left-minutes"
          [ngStyle]="{'width': (100 - realisedLifeInPercent) + '%'}"
          [matTooltip]="'Życie: pozostało ' + (floor((iddTraining.leftLifeMinutes) / 60).toString() | number:'1.0-0') + 'h ' +
            ((floor(iddTraining.leftLifeMinutes) % 60).toString() | number:'1.0-0') + 'min'"
          matTooltipPosition="above"
        ></div>
      </div>


      <div
        *ngIf="iddTraining.requiredGeneralMinutes"
        class="chart-background-green"
        [ngStyle]="{'width': (100 * iddTraining.requiredGeneralMinutes / totalRequiredMinutes) + '%'}"
      >
        <div
          class="chart-realised"
          [ngStyle]="{'width': realisedGeneralInPercent + '%'}"
          [matTooltip]="'Ogólne: zrealizowane ' + (floor((iddTraining.requiredGeneralMinutes - iddTraining.leftGeneralMinutes) / 60).toString() | number:'1.0-0') + 'h ' +
            (floor((iddTraining.requiredGeneralMinutes - iddTraining.leftGeneralMinutes) % 60).toString() | number:'1.0-0') + 'min'"
          matTooltipPosition="above"
        >

        </div>

        <div
          class="chart-left-minutes"
          [ngStyle]="{'width': (100 - realisedGeneralInPercent) + '%'}"
          [matTooltip]="'Ogólne: pozostało ' + (floor((iddTraining.leftGeneralMinutes) / 60).toString() | number:'1.0-0') + 'h ' +
            ((floor(iddTraining.leftGeneralMinutes) % 60).toString() | number:'1.0-0') + 'min'"
          matTooltipPosition="above"
        ></div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="chartType === halfDoughnutChartType">

  </ng-container>
</div>
